module.exports = __webpack_public_path__ + "static/OP2-40945537d3c38a47a808f9b10df8584c.png";